const AT_A_GLANCE = {
  URGENT: { label: 'Urgent', value: 'urgent' },
  COULD_BENEFIT: { label: 'Could benefit', value: 'couldBenefit' },
  GOOD_TO_GO: { label: 'Good to go', value: 'goodToGo' },
  DIDNT_CHECK_IN: { label: "Didn't check-in", value: 'didntCheckIn' },
  ALL: { label: 'All', value: 'all' },
} as const

export default AT_A_GLANCE
